<script>
  import ClickOut from '../../../../utils/directives/clickout'

  export default {
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li>
    <a>
      <i class="icon-graph icon "></i>
      <span>BI</span>
    </a>
    <!--<ul class="nav nav-sub dk">
        <li class="nav-sub-header"><a><span class="text-muted">BI</span></a></li>
        <li><a><span>Dashboard</span></a></li>
        <li><a><span>Clientes</span></a></li>
        <li><a><span>Controle de pontos</span></a></li>
        <li><a><span>Rede conveniada</span></a></li>
        <li><a><span>Relatórios</span></a></li>
        <li><a><span>Configurações</span></a></li>
    </ul>-->
  </li>
</template>



// WEBPACK FOOTER //
// BI.vue?4a8a7c2b